import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { useSidenavContext as m } from "../context.js";
import n from "./Footer.js";
import s from "./Head.js";
import f from "./List.js";
import { StyledMenu as p, MenuOffset as d } from "./styles.js";
const O = (o) => {
  const { isOpen: r, items: t } = m();
  return /* @__PURE__ */ e(p, { $isOpen: r, children: /* @__PURE__ */ i(d, { children: [
    /* @__PURE__ */ e(s, {}),
    /* @__PURE__ */ e(f, { items: t }),
    /* @__PURE__ */ e(n, { ...o })
  ] }) });
};
export {
  O as default
};
